import React from "react";

const Header = () => {
  return (
    <header>
      <h1>Getting Things Done</h1>
    </header>
  );
};

export default Header;
